.label {
  color: var(--paletteBlue2);
}
